(function(){
  var cfg = window.eliteConfig || {};
  function money(c){
    try{ if(window.theme && theme.Currency) return theme.Currency.formatMoney(c, theme.settings.moneyFormat); }catch(e){}
    return (c/100).toLocaleString();
  }

  /* ---------- Free shipping bar ---------- */
  function renderShip(cart){
    if(!cfg.shipThreshold) return;
    var drawer = document.getElementById('CartDrawer');
    if(!drawer) return;
    var host = drawer.querySelector('.drawer__scrollable');
    if(!host) return;
    var bar = drawer.querySelector('.elite-ship');
    if(!bar){
      bar = document.createElement('div');
      bar.className = 'elite-ship';
      bar.innerHTML = '<div class="elite-ship__text"></div><div class="elite-ship__track"><div class="elite-ship__fill"></div></div>';
      host.insertBefore(bar, host.firstChild);
    }
    var goal = cfg.shipThreshold * 100, total = cart.total_price, left = Math.max(goal - total, 0);
    var pct = Math.min(100, Math.round(total / goal * 100));
    bar.hidden = cart.item_count === 0;
    bar.classList.toggle('is-done', left === 0);
    bar.querySelector('.elite-ship__text').textContent = left === 0 ? cfg.msgDone : cfg.msgProgress.replace('[amount]', money(left));
    requestAnimationFrame(function(){ bar.querySelector('.elite-ship__fill').style.width = pct + '%'; });
  }
  function refreshShip(){
    if(!cfg.shipThreshold) return;
    fetch((window.theme && theme.routes && theme.routes.cart) || '/cart.js', {credentials:'same-origin'})
      .then(function(r){return r.json();}).then(renderShip).catch(function(){});
  }
  ['cart:updated','cart:build','cart:open','ajaxProduct:added'].forEach(function(ev){
    document.addEventListener(ev, function(){ setTimeout(refreshShip, 350); });
  });
  document.addEventListener('DOMContentLoaded', refreshShip);

  /* ---------- Sticky add to cart ---------- */
  function initSticky(){
    var bar = document.querySelector('[data-elite-sticky]');
    var target = document.querySelector('.product-single__form [data-add-to-cart], [data-add-to-cart]');
    if(!bar || !target) return;
    var btn = bar.querySelector('.elite-sticky__btn');
    var priceEl = bar.querySelector('.elite-sticky__price');
    var mainBtn = target;
    var io = new IntersectionObserver(function(entries){
      var e = entries[0];
      bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, {threshold:0});
    io.observe(mainBtn);
    function sync(){
      var p = document.querySelector('[data-product-price]');
      if(p && priceEl) priceEl.textContent = p.textContent.trim();
      var t = mainBtn.querySelector('[data-add-to-cart-text]');
      if(t) btn.querySelector('span').textContent = t.textContent.trim();
      btn.disabled = mainBtn.disabled;
    }
    btn.addEventListener('click', function(){ if(!mainBtn.disabled) mainBtn.click(); });
    document.addEventListener('variant:change', function(){ setTimeout(sync, 60); });
    new MutationObserver(sync).observe(mainBtn, {attributes:true, childList:true, subtree:true, characterData:true});
    sync();
  }
  document.addEventListener('DOMContentLoaded', initSticky);
})();
